<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-lg-6 com-md-9 col-sm-12 d-flex justify-content-start"
          ></div>
          <div class="col-lg-6 com-md-3 col-sm-12 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px"
              class="ml-2"
            />
            <ts-button
              v-show="isStaff"
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.branch.branch_name_en }}</td>
          <td>{{ record.contact_name }}</td>
          <td>{{ record.position ? record.position.pos_name_en : '' }}</td>
          <td>{{ record.phone_number }}</td>
          <td>{{ record.email }}</td>
          <td class="text-center">
            <a
              v-show="isStaff"
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              v-show="isStaff"
              href="#"
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-drawer
      :title="$t('filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <ts-branch-filter @filter="value => (branch_id = value)" />
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  props: ['fetch'],
  name: 'school-contact-table',
  data () {
    return {
      loading: false,
      branch_id: [],
      visible: false,
      columns: [
        { name: this.$t('schoolcontact.branch') },
        { name: this.$t('schoolcontact.contactName') },
        { name: this.$t('schoolcontact.position') },
        { name: this.$t('schoolcontact.phoneNumber') },
        { name: this.$t('schoolcontact.email') },
        { name: this.$t('actions'), style: 'text-align:center; width:1px' }
      ]
    }
  },
  created () {
    if (this.isParent) {
      this.branch_id = []
      this.branch_id.push(this.$store.state.selectedStudent.branch_id)
    } else {
      this.fetchData()
    }
  },
  computed: {
    ...mapState('schoolContact', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.schoolContact.search
      },
      set (newValue) {
        this.$store.commit('schoolContact/SET_SEARCH', newValue)
        this.$store.commit('schoolContact/RESET_CURRENT_PAGE')
      }
    },
    isStaff () {
      return this.$store.getters.isStaffLogin
    },
    isParent () {
      return this.$store.getters.isParentLogin
    },
    selectedStudent () {
      return this.$store.state.selectedStudent.student_id
    },
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'schoolContact/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit (record) {
      this.$store.commit('schoolContact/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'school-contact-edit',
        params: { id: record.scc_id }
      })
    },
    async destroy (record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('schoolContact/destroy', record.scc_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500),
    selectedStudent: debounce(function () {
      if (this.isParent) {
        this.branch_id = []
        this.branch_id.push(this.$store.state.selectedStudent.branch_id)
      }
    }, 500),
    fetch: function () {
      this.fetchData()
      this.$emit('fetched')
    }
  }
}
</script>
